import React from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';

interface Props {
  content: string;
}

const MessageError: React.FC<Props> = ({ content }) => (
  <div className="uzy-tool-card" style={{ borderColor: '#ffccc7' }}>
    <div className="uzy-tool-card-header" style={{ background: '#fff2f0', borderBottomColor: '#ffccc7', color: '#ff4d4f' }}>
      <CloseCircleOutlined style={{ marginRight: 6 }} />错误
    </div>
    <div className="uzy-tool-card-body">{content}</div>
  </div>
);

export default MessageError;
